import {initInputStateSwitch} from './input.state-switch';
import {initGetAjaxForm} from './.get-ajax-form';
import {initDivMap} from './div.map';
import {initYagaLinks} from './[data-click-yaga]';
import {initYagaButtons} from './[data-yaga]';
import {initCookie} from './cookie';
import {initChangeLanguage} from './button.language';

export const initElements = () => {
	initInputStateSwitch();
	initGetAjaxForm();
	initDivMap();
	initYagaLinks();
	initYagaButtons();
	initCookie();
	initChangeLanguage();
};
